import { theme } from '@hhgtech/hhg-components'
import { Text } from '@hhgtech/hhg-components/mantine'
import { Box } from '@mantine/core'
import { useIntl } from 'react-intl'

import { assetImagePath } from 'interfaces/constants'

type Props = {
  featuredImage?: string
}

const DueDateIntroBanner = ({ featuredImage }: Props) => {
  const { formatMessage: f } = useIntl()

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 24,
        padding: 24,
        marginBottom: 40,
        borderRadius: 16,
        backgroundColor: theme.colors.pink100,
        alignItems: 'center',
      }}
    >
      <Box w={96} h={96} miw={96} pos="relative">
        {featuredImage ? (
          <img
            src={featuredImage}
            alt=""
            loading="lazy"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : (
          <img
            src={`${assetImagePath}/due-date-calendar-illustration.svg`}
            alt=""
            loading="lazy"
            style={{
              position: 'absolute',
              top: -16,
              left: -20,
              width: 136,
              height: 136,
              maxWidth: 'none',
              maxHeight: 'none',
            }}
          />
        )}
      </Box>
      <Box>
        <Text size="h5" weight="semiBold" color={theme.colors.gray800}>
          {f({
            id: 'dueDatePage.introduce.title',
            defaultMessage:
              'Find your due date and navigating your pregnancy journey',
          })}
        </Text>
        <Text size="p4" mt={8} color={theme.colors.gray700}>
          {f({
            id: 'dueDatePage.introduce.description',
            defaultMessage:
              'Use this calculator to find your due date. This is just an estimate - not a guarantee! Most women, but not all, will deliver their babies within a week before or after this date range.',
          })}
        </Text>
      </Box>
    </Box>
  )
}

export default DueDateIntroBanner
